module.exports = __webpack_public_path__ + "img/Step1-m.68c52c7.svg";